import { Box, Grid } from '@mui/material';

import ModalTrigger from '../Common/ModalTrigger';

import csv8 from '../../Data/MANCP/FoodProduct/MANCP-Number-of-different-pesticides-found-in-each-animal-food-group.csv';

import GradientColumnsChart from '../Charts/GradientColumnsChart';

const PesticideResiduesResults = (props) => {
	return (
		<Grid
			item
			container
			direction='column'
			sx={{ marginTop: { xs: '50px', sm: '50px', md: '90px' } }}
			alignContent='center'
		>
			<Grid
				item
				xs
				sx={{
					paddingLeft: { xs: '24px', sm: '24px', md: '24px' },
					paddingRight: { xs: '45px', sm: '45x', md: '24px' },
					paddingBottom: { xs: '24px', sm: '24px', md: '24px' }
				}}
				className='nine-one'
			>
				<Box className='nine-one-inner'>
					<h3>Results for animal products</h3>
					<p className='paragraph'>
					A total of 20,700 samples of animal products were reported. The results showed that 18,628 samples were free of quantifiable residues (90.0% vs 92.4% in 2022) while 1,907 samples (9.2% vs 6.6% in 2022) contained pesticides in quantifiable concentrations. MRL exceedance was identified in 166 samples (0.8% vs 1.0% 2022), of which 121 (0.6%) were deemed non-compliant when measurement uncertainty was taken into account.
					</p>
					<p className='paragraph'>
					The pesticides most frequently detected above the LOQ but below the MRL (higher than 10%) were: honey and other apicultural products (21 samples), bovine liver (18 samples), bovine fat (15 samples) and deer fresh meat (14 samples). 
					</p>
					<p className='paragraph'>
					The pesticides with a higher quantification rate were bromide ion (11.1%) and copper compounds (3.6%).
					</p>
				</Box>
			</Grid>
			<Grid
				item
				xs
				p={3}
				className='nine-two'
				justifyContent='center'
				alignItems='center'
			>
				<GradientColumnsChart
					csv={csv8}
					title='Number of different pesticides found in each animal food group'
				/>
			</Grid>
			<Grid
				item
				xs
				sx={{
					paddingLeft: { xs: '24px', sm: '24px', md: '24px' },
					paddingRight: { xs: '45px', sm: '45x', md: '24px' },
					paddingBottom: { xs: '24px', sm: '24px', md: '24px' }
				}}
			>
				<Box className='chartInfoTitle'>
					<p>
						”Honey” and “Wild animals” refer to “Honey and other apicultural
						products” and “Wild terrestrial vertebrate animals”, respectively.
					</p>
				</Box>
			</Grid>
		</Grid>
	);
};

export default PesticideResiduesResults;
